import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { ddexImportQueryKeys } from '../config/queryKeys';
import { DdexClient } from '../lib/DdexClient';
import { getRequestHeaders } from '../lib/headers';
import type { DdexImportList } from '../lib/schemas';
import { DdexImportListSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

// TODO WMG1-510 - Add proper types for variables
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ImportsHistoryQueryVariables {}

export function useImportsHistory<TData = DdexImportList>(
  variables: ImportsHistoryQueryVariables,
  options?: PresetUseQueryOptions<DdexImportList, TData>,
) {
  const session = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: ddexImportQueryKeys.list(variables),
    queryFn: async () => {
      const responseData = await DdexClient.get('v1/releases/history/list', {
        headers: getRequestHeaders(session.token),
        searchParams: { ...variables },
      }).json();

      return DdexImportListSchema.parse(responseData);
    },
    placeholderData: keepPreviousData,
    ...options,
  });

  return { importsHistoryList: data, ...query };
}
